/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* A single point in an anomaly time-series chart
*/
export class AnomalyDataPoint {
  /**
  * Timestamp of the data point
  */
  'timestamp': Date;
  /**
  * The actual observed value
  */
  'actualValue': number;
  /**
  * The forecasted/expected value
  */
  'forecastValue': number;
  /**
  * Upper bound of the expected range
  */
  'upperBound': number;
  /**
  * Lower bound of the expected range
  */
  'lowerBound': number;
  /**
  * Whether this data point is flagged as an anomaly
  */
  'isAnomaly': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "timestamp",
      "baseName": "timestamp",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "actualValue",
      "baseName": "actualValue",
      "type": "number",
      "format": "double"
    },
    {
      "name": "forecastValue",
      "baseName": "forecastValue",
      "type": "number",
      "format": "double"
    },
    {
      "name": "upperBound",
      "baseName": "upperBound",
      "type": "number",
      "format": "double"
    },
    {
      "name": "lowerBound",
      "baseName": "lowerBound",
      "type": "number",
      "format": "double"
    },
    {
      "name": "isAnomaly",
      "baseName": "isAnomaly",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AnomalyDataPoint.attributeTypeMap;
  }

  public constructor() {
  }
}

